export class IEvent {
    constructor(){
        this.originalEvent = null;
        this.type = null;
        this.data = null;
        this.target = null;
    }
}
